import { I18n } from "@assets/strings";
import React, { useEffect } from "react";
import { ClipLoader } from "react-spinners";
import styled from "styled-components";
import { Path } from "@core/routing/path";
import { useServices } from "@core/servicesContext";
import { useDetailedCourse } from "@domain/lms/course/hooks";
import { Page } from "@ui/components/page";
import { NotFoundPage } from "@ui/pages/notFoundPage";
import { CourseContent } from "./courseContent";

interface CourseContentPageProps extends React.HTMLAttributes<HTMLDivElement> {
	courseId: string;
	chapterIndex: number;
}

export const CourseContentPage: React.FC<CourseContentPageProps> = ({ courseId, chapterIndex, ...htmlProps }) => {
	const { loading, result: course, error } = useDetailedCourse(courseId);
	const { trackingService } = useServices();

	useEffect(() => {
		const event = "course / reading";
		//trackingService.time(event);
		return () => trackingService.track(event);
	}, []);

	if (error?.code === 404) {
		return <NotFoundPage message={I18n.t("404.course")} />;
	}

	return (
		<Container {...htmlProps} backText={I18n.t("course.content.back")} backPath={Path.Lms.Course(courseId)}>
			{loading ? <ClipLoader /> : course ? <FullSizeContent course={course} chapterIndex={chapterIndex} /> : null}
		</Container>
	);
};

const Container = styled(Page)`
	display: flex;
	flex-direction: column;
	align-items: center;
`;

const FullSizeContent = styled(CourseContent)`
	width: 100%;
`;
